import ArticlePreview from './ArticlePreview'

export default ArticlePreview
